import React, { Component } from "react";
import {
  loadReglements,
  saveReglement,
  saveReglementLigne,
} from "../../store/actions/reglementAction";
import {saveEcriture, saveEcritureHonoraire} from "../../store/actions/ecritureAction";

import { Spin } from "antd";
import FormReglement from "../../components/FormReglement";
import { connect } from "react-redux";
import { loadLocataires } from "../../store/actions/locataireAction";
import { loadLocations } from "../../store/actions/locationAction";
import { loadQuittances } from "../../store/actions/quittanceAction";
import { loadComptes } from "../../store/actions/compteAction";
import FormReglementCorse from "../../components/FormReglementCorse";

class Reglement extends Component {
  componentDidMount() {
    Promise.all([
      !this.props.quittances && this.props.loadQuittances(),
      !this.props.reglements && this.props.loadReglements(),
      !this.props.comptes && this.props.loadComptes(),
      !this.props.locataires && this.props.loadLocataires(),
      !this.props.locations && this.props.loadLocations(),
    ]);
  }

  render() {
    const {
      idLocataire,
      journals,
      comptes,
      locataires,
      locations,
      quittances,
      quittancesHorsExercice,
      reglements,
      typesPaiements
    } = this.props;

    return (
      <Spin
        size="large"
        tip="Chargement en cours..."
        spinning={!comptes || !locataires || !locations || !quittances || !reglements}
      >

        {/* TODO : ici formulaire pour la corse (rustine ultra pourri dans un code pourri) */}
        {(this.props.utilisateur.societe_id === 21 || this.props.utilisateur.societe_id === 45) && (
          <FormReglementCorse
            idLocataire={idLocataire}
            locataires={locataires}
            journals={journals}
            comptes={comptes}
            locations={locations}
            quittances={quittances}
            quittancesHorsExercice={quittancesHorsExercice}
            reglements={reglements}
            typesPaiements={typesPaiements}
            saveReglement={this.props.saveReglement}
            saveReglementLigne={this.props.saveReglementLigne}
            saveEcriture={this.props.saveEcriture}
            saveEcritureHonoraire={this.props.saveEcritureHonoraire}
          />
        )}

        {!(this.props.utilisateur.societe_id === 21 || this.props.utilisateur.societe_id === 45) && (
        <FormReglement
          idLocataire={idLocataire}
          locataires={locataires}
          journals={journals}
          comptes={comptes}
          locations={locations}
          quittances={quittances}
          quittancesHorsExercice={quittancesHorsExercice}
          reglements={reglements}
          typesPaiements={typesPaiements}
          saveReglement={this.props.saveReglement}
          saveReglementLigne={this.props.saveReglementLigne}
          saveEcriture={this.props.saveEcriture}
        />
          )}
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadComptes: () => dispatch(loadComptes()),
    loadLocataires: () => dispatch(loadLocataires()),
    loadLocations: () => dispatch(loadLocations()),
    loadQuittances: () => dispatch(loadQuittances()),
    loadReglements: () => dispatch(loadReglements()),
    saveReglement: (jsonData) => dispatch(saveReglement(jsonData)),
    saveReglementLigne: (jsonData) => dispatch(saveReglementLigne(jsonData)),
    saveEcriture: (ecriture) => dispatch(saveEcriture(ecriture)),
    saveEcritureHonoraire: (jsonData) => dispatch(saveEcritureHonoraire(jsonData)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    journals: state.journals.data,
    comptes: state.comptes.data,
    locataires: state.locataires.data,
    locations: state.locations.data,
    quittances: state.quittances.data,
    quittancesHorsExercice: state.quittances.horsExercice,
    reglements: state.reglements.data,
    typesPaiements: state.typesPaiements.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reglement);
